import Link from 'next/link';
import cn from 'classnames';
import { Button, Heading, Picture, TextPassage } from '@petsmart-ui/sparky';
import { ContentfulClick } from '@libs/analytics';
import { propsImageItems } from '../../utils/propsImagesItems';
import { cutText } from '../../utils/cutText';
import { type CampaignHeroVariantProps } from './types';
import {
    COLOR_TABLE,
    NEW_TAB,
    PRIMARY_BUTTON_STYLE,
    SECONDARY_BUTTON_STYLE,
    TARGET_BLANK,
    TARGET_SELF,
} from '../../constants';
import './CampaignHeroSplit.scss';

export default function CampaignHeroSplit({
    preheader,
    header,
    body,
    cta,
    primaryTextColor,
    secondaryTextColor = 'Dark Grey',
    background,
    image,
    internalTitle,
}: CampaignHeroVariantProps) {
    const imageItems = propsImageItems(image);
    const primaryColorStyle = { color: COLOR_TABLE[primaryTextColor] };
    const secondaryColorStyle = { color: COLOR_TABLE[secondaryTextColor] };
    const WrapperComponent = cta ? Link : 'div';

    return (
        <ContentfulClick
            component={WrapperComponent}
            className="campaign-hero-split"
            href={cta?.link.webUrl || ''}
            target={cta?.behavior === NEW_TAB ? TARGET_BLANK : TARGET_SELF}
            prefetch={false}
            eventData={{
                linkText: cn(preheader, header, body, cta?.text),
                linkUrl: cta?.link.webUrl ?? '',
                promoTitle: header,
                promoVariant: 'campaign hero - split',
                promoDesc: internalTitle,
                promoType: 'campaign-hero-split',
            }}
        >
            <div className="campaign-hero-split__info-container" style={{ ...(background && { background }) }}>
                {preheader && (
                    <Heading className="preheader" tagName="h1" style={secondaryColorStyle}>
                        {preheader}
                    </Heading>
                )}
                <Heading className="header" tagName="h1" style={primaryColorStyle}>
                    {header}
                </Heading>
                {body && <TextPassage style={secondaryColorStyle}>{cutText(body, 40)}</TextPassage>}
                {cta && (
                    <Button
                        variant={
                            cta.buttonStyle.toLowerCase() === 'primary' ? PRIMARY_BUTTON_STYLE : SECONDARY_BUTTON_STYLE
                        }
                        text={cta.text}
                        fullWidth={false}
                        size="lg"
                    />
                )}
            </div>
            <Picture imgAlt={image.webAltText} imgSrc={imageItems[0]?.srcSet} items={imageItems} />
        </ContentfulClick>
    );
}
